function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.contract0{fill:#FFFFFF;}\r\n\t.contract1{fill:#98DB91;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "contract0",
  d: "M394.4,103.8l-89.5-88C295.3,6.4,282.3,1,268.8,1H51.1C22.8,1.1-0.1,23.7-0.1,51.5V488 c0,27.8,22.9,50.4,51.2,50.4h307.2c28.3,0,51.2-22.6,51.2-50.4V139.5C409.4,126.2,404,113.3,394.4,103.8L394.4,103.8z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("path", {
  className: "contract1",
  d: "M209.7,376.3l-13.9-41.6c-3.3-9.8-12.4-16.4-22.8-16.4s-19.5,6.6-22.8,16.4L132,389.4 c-1.5,4.6-5.8,7.6-10.6,7.6H109c-8.8,0-16,7.2-16,16s7.2,16,16,16h12.4c18.6,0,35.1-11.9,41-29.5l10.6-31.9l16.8,50.5 c2.1,6.1,7.6,10.4,14.1,10.9c0.4,0,0.8,0,1.1,0c6,0,11.6-3.4,14.3-8.9l7.7-15.3c2.8-5.6,7.9-6.2,10-6.2s7.3,0.6,10.2,6.5 c7.4,14.7,22.2,23.8,38.6,23.8H301c8.8,0,16-7.2,16-16s-7.2-16-16-16h-15.2c-4.3,0-8.1-2.4-10.2-6.5 C263.7,366.6,229.4,360.2,209.7,376.3L209.7,376.3z M85,109h112c4.4,0,8-3.6,8-8V85c0-4.4-3.6-8-8-8H85c-4.4,0-8,3.6-8,8v16 C77,105.4,80.6,109,85,109z M205,165v-16c0-4.4-3.6-8-8-8H85c-4.4,0-8,3.6-8,8v16c0,4.4,3.6,8,8,8h112C201.4,173,205,169.4,205,165 z M382.9,111L299,27.1c-9-9-21.2-14.1-33.9-14.1H61c-26.5,0.1-48,21.6-48,48.1V477c0,26.5,21.5,48,48,48h288c26.5,0,48-21.5,48-48 V145C397,132.3,391.9,120,382.9,111L382.9,111z M269,45.6c2.8,0.7,5.3,2.1,7.4,4.2l83.9,83.9c2.1,2.1,3.5,4.6,4.2,7.4H269V45.6z  M365,477c0,8.8-7.2,16-16,16H61c-8.8,0-16-7.2-16-16V61.1C45,52.3,52.2,45,61,45h176v104.1c0,13.3,10.7,23.9,24,23.9h104V477z"
}));

const SvgIconContract = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 410 539.4",
    style: {
      enableBackground: "new 0 0 410 539.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconContract, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-contract.8fb8ec53.svg";
export { ForwardRef as ReactComponent };